document.addEventListener('DOMContentLoaded', function () {

  /* ============================================================
     ELEMENTS
  ============================================================ */
  const cartSections = document.querySelectorAll('#cart-component');   // supports drawer + cart page
  const cartDrawer = document.querySelector('#cart-drawer');
  const overlay = document.querySelector('#cart-overlay');
  const headerCartButton = document.querySelector('#cart-open-btn');   // your real header button
  const closeDrawerBtn = document.querySelector('#cart-close-btn');

  const freeThreshold = window.cartConfig?.freeShippingThreshold || 8000;
  const formatMoney = (cents) => (cents / 100).toFixed(2);


  /* ============================================================
     UPDATE THE CART HTML + TEXT VALUES
  ============================================================ */
  function updateCartUI(cart) {

  /* Update header cart count */
  const cartCountEl = document.querySelector('.cart-count');
  if (cartCountEl) cartCountEl.innerText = `(${cart.item_count})`;

  /* Update all cart sections (drawer + cart page) */
  cartSections.forEach(section => {

    const totalEl = section.querySelector('#cart-total');
    const container = section.querySelector('.cart-items');
    const shippingStatus = section.querySelector('.cart-shipping-status');

    if (totalEl) totalEl.innerText = "$" + formatMoney(cart.total_price);

    /* ---------- DISCOUNT / "YOU SAVED" ---------- */
    let originalPrice = 0;
    cart.items.forEach(i => {
      originalPrice += (i.original_line_price || i.line_price);
    });
    const discount = originalPrice - cart.total_price;

    // Try to find existing savings wrapper + span
    let savingsWrapper = section.querySelector('.savings');
    let discountEl = section.querySelector('#discount-price');

    if (discount > 0) {
      // If no wrapper exists (e.g. page loaded with 0 discount), create it
      if (!savingsWrapper) {
        const pricingContainer = section.querySelector('.cart-pricing');
        if (pricingContainer) {
          savingsWrapper = document.createElement('p');
          savingsWrapper.className = 'savings font-body-3 font-avenir-medium text-left text-dark';
          savingsWrapper.innerHTML = `
            You Saved <span id="discount-price"></span>
          `;
          pricingContainer.appendChild(savingsWrapper);
          discountEl = savingsWrapper.querySelector('#discount-price');
        }
      }

      if (discountEl) {
        discountEl.textContent = '-$' + formatMoney(discount);
      }
      if (savingsWrapper) {
        savingsWrapper.style.display = 'flex';
      }

    } else {
      // No discount -> hide savings if it exists
      if (savingsWrapper) {
        savingsWrapper.style.display = 'none';
      }
    }

    /* ---------- SHIPPING STATUS ---------- */
    if (shippingStatus) {
      if (cart.total_price >= freeThreshold) {
        shippingStatus.innerHTML = `
          <p class="font-body-3 font-avenir-medium text-uppercase text-dark">
            Congratulations! You have free shipping.
          </p>
          <div class="progress-bar"><div class="progress" style="width:100%;"></div></div>
        `;
      } else {
        const remaining = freeThreshold - cart.total_price;
        const percent = (cart.total_price / freeThreshold) * 100;
        shippingStatus.innerHTML = `
          <p class="font-body-3 font-avenir-medium text-uppercase text-dark">
            You are <span id="amount-away">$${formatMoney(remaining)}</span> away from free shipping.
          </p>
          <div class="progress-bar">
            <div class="progress" style="width:${percent.toFixed(2)}%;"></div>
          </div>
        `;
      }
    }

    /* ---------- RENDER CART ITEMS ---------- */
    if (container) {
      container.innerHTML = "";

      if (cart.items.length === 0) {
        container.innerHTML = `
          <div class="empty-cart-message font-body-2 text-center text-dark" style="padding:30px;">
            Your cart is empty.
          </div>
        `;
        return;
      }

      cart.items.forEach(item => {
        container.insertAdjacentHTML("beforeend", `
          <div class="cart-item" data-key="${item.key}">
            <div class="item-details">
              <img src="${item.image}" alt="${item.product_title}">
              <div class="item-text">
                <p class="title font-body-3 font-avenir-semibold text-left text-dark">
                  ${item.product_title}
                </p>
                <p class="price font-body-3 font-avenir-semibold text-left text-dark">
                  ${
                    item.line_price < item.original_line_price
                      ? `<span class="original-price" style="text-decoration: line-through; opacity:0.5; margin-right:6px;">
                          $${formatMoney(item.original_line_price)}
                         </span>`
                      : ''
                  }
                  $${formatMoney(item.line_price)}
                </p>
              </div>
            </div>

            <div class="item-quantity">
              <button class="quantity-btn decrement" type="button"><span></span></button>
              <p class="quantity-number font-body-3 font-avenir-medium text-left text-dark">
                ${item.quantity}
              </p>
              <button class="quantity-btn increment" type="button"><span></span><span></span></button>
            </div>
          </div>
        `);
      });
    }
  });
}


  /* ============================================================
     FETCH CART
  ============================================================ */
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        updateCartUI(cart);
        return cart;
      })
      .catch(err => console.error('Error fetching cart:', err));
  }


  /* ============================================================
     CHANGE CART ITEM QUANTITY
  ============================================================ */
  function changeCartItem(key, quantity) {
    const updatingMsgs = document.querySelectorAll('#cart-updating-message');
    const qtyButtons = document.querySelectorAll('.quantity-btn');

    // Show ALL “Updating Cart...” banners
    updatingMsgs.forEach(msg => msg.style.display = 'block');

    qtyButtons.forEach(b => b.disabled = true);

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(key), quantity })
    })
      .then(res => {
        if (!res.ok) return res.json().then(err => { throw err; });
        return res.json();
      })
      .then(cart => {
        updateCartUI(cart);
        return cart;
      })
      .catch(err => console.error('Error changing quantity:', err))
      .finally(() => {
        // Hide ALL banners again
        updatingMsgs.forEach(msg => msg.style.display = 'none');
        qtyButtons.forEach(b => b.disabled = false);
      });
  }


  /* ============================================================
     QUANTITY BUTTON LISTENER (applies to *ALL* cart sections)
  ============================================================ */
  document.body.addEventListener('click', function (event) {
    const btn = event.target.closest('.quantity-btn');
    if (!btn) return;

    const itemEl = btn.closest('.cart-item');
    const key = itemEl?.dataset.key;
    if (!key) return;

    const qtyEl = itemEl.querySelector('.quantity-number');
    const currentQty = parseInt(qtyEl.innerText, 10);

    const delta = btn.classList.contains('increment') ? 1 : -1;
    const newQty = Math.max(currentQty + delta, 0);

    changeCartItem(key, newQty);
  });


  /* ============================================================
     DRAWER TOGGLE
  ============================================================ */
  function toggleCartDrawer() {
    if (!cartDrawer || !overlay) return;

    const isOpen = cartDrawer.classList.contains('open');
    if (isOpen) {
      cartDrawer.classList.remove('open');
      overlay.classList.remove('active');
      document.body.classList.remove('cart-open');
    } else {
      cartDrawer.classList.add('open');
      overlay.classList.add('active');
      document.body.classList.add('cart-open');
      fetchCart();
    }
  }

  const isCartPage = window.location.pathname === '/cart';

  // Update this section:
  headerCartButton?.addEventListener('click', function (event) {
    if (isCartPage) {
      // Don't toggle drawer on /cart page
      return;
    }

    event.preventDefault();
    toggleCartDrawer();
  });

  closeDrawerBtn?.addEventListener('click', toggleCartDrawer);
  overlay?.addEventListener('click', toggleCartDrawer);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') toggleCartDrawer();
  });


  /* ============================================================
     ADD TO CART BUTTONS
  ============================================================ */
  document.body.addEventListener('click', async function (event) {

    const addBtn = event.target.closest('[data-add-to-cart]');
    if (!addBtn) return;

    event.preventDefault();

    const productId = addBtn.getAttribute('data-product-id');
    const quantity = parseInt(addBtn.getAttribute('data-quantity')) || 1;

    if (!productId) {
      console.error("Add-to-cart button missing data-product-id");
      return;
    }

    addBtn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: productId,
          quantity: quantity
        })
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err?.description || "Add to cart failed");
      }

      await fetchCart();
      toggleCartDrawer();

    } catch (err) {
      console.error("Add to cart error:", err);
      alert(err.message);
    }

    addBtn.disabled = false;
  });


  /* ============================================================
     INITIAL LOAD
  ============================================================ */
  fetchCart();

});
